import { isErrorCode } from '@lib/errors/error-code';
import { useClientTranslation } from '@lib/i18n/client';
import { captureErrorCode } from '@lib/sentry/capture-error-code';
import { DialogBody } from '@modules/get-slash-internet-card/components/dialog-views/dialog-body';
import { Trans } from '@tuic/i18n';
import { Pictogram } from '@tuic/web-compositions/core/Pictogram';
import { useEffect } from 'react';

import type { ErrorCode } from '@lib/errors/error-code';
import type { FC } from 'react';

type Props = {
  error: ErrorCode | string;
};

export const ErrorView: FC<Props> = props => {
  const { error } = props;

  const { t } = useClientTranslation();

  useEffect(() => {
    // Only capture if it's a valid ErrorCode
    if (isErrorCode(error)) {
      captureErrorCode(error, 'InternetCardDialogErrorView');
    }
  }, [error]);

  return (
    <DialogBody>
      <div className="space-y-6 text-center text-marine-80 text-marine-high-emphasis">
        <Pictogram name="lifebuoy" size="md" className="inline-block" />
        <div className="space-y-2">
          <div className="headline-sm">
            {t('Authentifizierung nicht möglich.')}
          </div>
          <div className="text-base [&_strong:font-semibold]">
            <Trans>
              Die Administration Ihres Internettarifs ist derzeit nicht möglich.
              <br />
              <br />
              Bitte versuchen Sie es erneut unter{' '}
              <a
                href="https://internet.meinschiff.de"
                className="underline hover:no-underline"
                target="_blank"
                rel="noreferrer"
              >
                https://internet.meinschiff.de
              </a>{' '}
              im Browser. Wenden Sie sich anschließend mit dem Fehlercode #
              {{ error } as any} an unseren Gästeservice.
            </Trans>
          </div>
        </div>
      </div>
    </DialogBody>
  );
};
